import * as THREE from 'three';

const MAX_PARTICLES = 400;

/** THREE.Points smog field — density scales with pollution via setDensity(0..1). */
export class SmogParticles {
  readonly points: THREE.Points;
  private readonly material: THREE.PointsMaterial;
  private readonly geometry: THREE.BufferGeometry;

  constructor(spread = 10, height = 3) {
    this.geometry = new THREE.BufferGeometry();
    const positions = new Float32Array(MAX_PARTICLES * 3);
    for (let i = 0; i < MAX_PARTICLES; i += 1) {
      positions[i * 3] = (Math.random() - 0.5) * spread * 2;
      positions[i * 3 + 1] = Math.random() * height;
      positions[i * 3 + 2] = (Math.random() - 0.5) * spread * 2;
    }
    this.geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));

    this.material = new THREE.PointsMaterial({
      color: '#8a8368',
      size: 0.22,
      transparent: true,
      opacity: 0,
      depthWrite: false,
    });

    this.points = new THREE.Points(this.geometry, this.material);
    this.geometry.setDrawRange(0, 0);
  }

  /** @param density 0 (invisible) to 1 (max smog) */
  setDensity(density: number): void {
    const clamped = THREE.MathUtils.clamp(density, 0, 1);
    this.geometry.setDrawRange(0, Math.round(MAX_PARTICLES * clamped));
    this.material.opacity = clamped * 0.55;
  }

  update(delta: number): void {
    this.points.rotation.y += delta * 0.02;
  }

  dispose(): void {
    this.geometry.dispose();
    this.material.dispose();
  }
}
